module.exports = require("./af-ZA.js");